import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import classnames from 'classnames';
import FieldInput from 'common/components/FieldInput';
import FieldInputEditMode from "common/components/FieldInputEditMode";
import {limitValueRange, limitValueRangeFloat} from 'common/utils/form/limitValueLength';
import ButtonsSubmitCancel from "../ButtonsSubmitCancel";
import UploadingFilePopUp from "common/components/UploadingFilePopUp/UploadingFilePopUp";
import {divideThousandsInteger, formatStringToNumber} from '../../../../common/utils/formatting';
import styles from './styles.module.scss';


const Form_10View = ({
                       values,
                       prevPagePath,
                       nextPagePath,
                       handleDataSubmit,
                       dirty,
                       showUploadingFilePopUp,
                       progress,
                       houseJointHomeRegistered,
                       shumaTypeID,
                     }) => {

  return (
    <div className={styles.form_10}>
      <Form>
        <div className={styles.unit_1}>
          <h3 className={styles.unitHeader}>נתונים כלליים</h3>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="totalRegisteredArea"
                type={"text"}
                value={values.totalRegisteredArea}
                label="סך שטח רשום"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="totalRoomCount"
                type={"text"}
                value={values.totalRoomCount}
                label="סך חדרים"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="totalPrice"
                type={"text"}
                value={values.totalPrice}
                label="סך מחיר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageSqmPrice"
                type={"text"}
                value={values.averageSqmPrice}
                label='מחיר ממוצע למ"ר'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageRoomPrice"
                type={"text"}
                value={values.averageRoomPrice}
                label="מחיר ממוצע לחדר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageRoomSq"
                type={"text"}
                value={values.averageRoomSq}
                label="שטח ממוצע לחדר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageSqmPriceSD"
                type={"text"}
                value={values.averageSqmPriceSD}
                label='סטיית תקן ממוצע למ"ר'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageSqmPriceUpperBorder"
                type={"text"}
                value={values.averageSqmPriceUpperBorder}
                label='גבול עליון ממוצע למ"ר'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.halfField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageSqmPriceLowerBorder"
                type={"text"}
                value={values.averageSqmPriceLowerBorder}
                label='גבול תחתון ממוצע למ"ר'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="deviationPercent"
                type={"text"}
                value={values.deviationPercent}
                label='אחוז סטייה'
                disabled
                showPercentIcon={true}
              />
            </div>
          </div>
        </div>
        <div className={styles.unit_2}>
          <h3 className={styles.unitHeader}>חישוב לפי שווי מ"ר דירתי מתואם</h3>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="housePermitArea"
                type={"text"}
                value={values.housePermitArea}
                label="שטח מגורים"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="housePermitAreaWeightedValue"
                type={"text"}
                value={values.housePermitAreaWeightedValue}
                label="מקדם אקוו"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="housePermitAreaAdjusted"
                type={"text"}
                value={values.housePermitAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseBalconyOpenPermitArea"
                type={"text"}
                value={values.houseBalconyOpenPermitArea}
                label="שטח מרפסות פתוחות"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="permitSqmOpenBalconyWeightedValue"
                type={"text"}
                value={values.permitSqmOpenBalconyWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={1}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmOpenBalconyAreaAdjusted"
                type={"text"}
                value={values.permitSqmOpenBalconyAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseBalconyClosedPermitArea"
                type={"text"}
                value={values.houseBalconyClosedPermitArea}
                label="שטח מרפסות סגורות"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="permitSqmClosedBalconyWeightedValue"
                type={"text"}
                value={values.permitSqmClosedBalconyWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={2}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmClosedBalconyAreaAdjusted"
                type={"text"}
                value={values.permitSqmClosedBalconyAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseYardPermitArea"
                type={"text"}
                value={values.houseYardPermitArea}
                label="שטח חצר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="permitSqmYardWeightedValue"
                type={"text"}
                value={values.permitSqmYardWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={3}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmYardAreaAdjusted"
                type={"text"}
                value={values.permitSqmYardAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRoofPermitArea"
                type={"text"}
                value={values.houseRoofPermitArea}
                label="שטח גג"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="permitSqmRoofWeightedValue"
                type={"text"}
                value={values.permitSqmRoofWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={4}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmRoofAreaAdjusted"
                type={"text"}
                value={values.permitSqmRoofAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseStoragePermitArea"
                type={"text"}
                value={values.houseStoragePermitArea}
                label="שטח מחסן"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="permitSqmStorageWeightedValue"
                type={"text"}
                value={values.permitSqmStorageWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={5}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmStorageAreaAdjusted"
                type={"text"}
                value={values.permitSqmStorageAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div
            className={classnames(
              styles.flexBetween,
              styles.marginBottom25,
              styles.reverseRow,
              styles.threeQuartersField
            )}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmTotalAdjustedArea"
                type={"text"}
                value={values.permitSqmTotalAdjustedArea}
                label="שטח כולל"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageSqmPrice"
                type={"text"}
                value={values.averageSqmPrice}
                label='שווי מ"ר דירתי ממוצע'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="permitSqmGeneralAdjustmentValue"
                type={"text"}
                value={values.permitSqmGeneralAdjustmentValue}
                label="מקדם אקוו"
                onChange={limitValueRangeFloat(5, 0, 99.99)}
                handleDataSubmit={handleDataSubmit}
                showPercentIcon={true}
                calcTypeId={6}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="permitSqmAveragePriceAdjusted"
                type={"text"}
                value={values.permitSqmAveragePriceAdjusted}
                label='שווי מ"ר דירתי מתואם'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="estimatePriceMethod1"
                type={"text"}
                value={values.estimatePriceMethod1}
                label="אומדן שווי"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
        </div>
        <div className={styles.unit_3}>
          <h3 className={styles.unitHeader}>חישוב לפי שווי חדר ממוצע מתואם</h3>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRegisteredArea"
                type={"text"}
                value={values.houseRegisteredArea}
                label="שטח מגורים"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomHouseRegisteredAreaWeightedValue"
                type={"text"}
                value={values.registeredRoomHouseRegisteredAreaWeightedValue}
                label="מקדם אקוו"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRegisteredAreaAdjusted"
                type={"text"}
                value={values.houseRegisteredAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseBalconyOpenRegisteredArea"
                type={"text"}
                value={values.houseBalconyOpenRegisteredArea}
                label="שטח מרפסות פתוחות"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredRoomOpenBalconyWeightedValue"
                type={"text"}
                value={values.registeredRoomOpenBalconyWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={7}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomOpenBalconyAreaAdjusted"
                type={"text"}
                value={values.registeredRoomOpenBalconyAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseBalconyClosedRegisteredArea"
                type={"text"}
                value={values.houseBalconyClosedRegisteredArea}
                label="שטח מרפסות סגורות"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredRoomClosedBalconyWeightedValue"
                type={"text"}
                value={values.registeredRoomClosedBalconyWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={8}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomClosedBalconyAreaAdjusted"
                type={"text"}
                value={values.registeredRoomClosedBalconyAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseYardRegisteredArea"
                type={"text"}
                value={values.houseYardRegisteredArea}
                label="שטח חצר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredRoomYardWeightedValue"
                type={"text"}
                value={values.registeredRoomYardWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={9}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomYardAreaAdjusted"
                type={"text"}
                value={values.registeredRoomYardAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRoofRegisteredArea"
                type={"text"}
                value={values.houseRoofRegisteredArea}
                label="שטח גג"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredRoomRoofWeightedValue"
                type={"text"}
                value={values.registeredRoomRoofWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={10}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomRoofAreaAdjusted"
                type={"text"}
                value={values.registeredRoomRoofAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseStorageRegisteredArea"
                type={"text"}
                value={values.houseStorageRegisteredArea}
                label="שטח מחסן"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredRoomStorageWeightedValue"
                type={"text"}
                value={values.registeredRoomStorageWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={11}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomStorageAreaAdjusted"
                type={"text"}
                value={values.registeredRoomStorageAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.threeQuartersField, styles.marginBottom25, styles.reverseRow)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomTotalAdjustedArea"
                type={"text"}
                value={values.registeredRoomTotalAdjustedArea}
                label="שטח רשום כולל"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.halfField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageRoomSq"
                type={"text"}
                value={values.averageRoomSq}
                label="שטח ממוצע לחדר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageRoomCount"
                type={"text"}
                value={values.averageRoomCount}
                label="חדרים/רישום"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageRoomPrice"
                type={"text"}
                value={values.averageRoomPrice}
                label="שווי חדר ממוצע"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredRoomGeneralAdjustmentValue"
                type={"text"}
                value={values.registeredRoomGeneralAdjustmentValue}
                label="מקדם אקוו"
                onChange={limitValueRangeFloat(5, 0, 99.99)}
                handleDataSubmit={handleDataSubmit}
                showPercentIcon={true}
                calcTypeId={12}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredRoomAveragePriceAdjusted"
                type={"text"}
                value={values.registeredRoomAveragePriceAdjusted}
                label="שווי חדר ממוצע מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="estimatePriceMethod2"
                type={"text"}
                value={values.estimatePriceMethod2}
                label="אומדן שווי"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
        </div>
        {houseJointHomeRegistered === 1 &&
        <div>
          <h3 className={styles.unitHeader}>חישוב לפי שווי מ"ר רשום מתואם</h3>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRegisteredArea"
                type={"text"}
                value={values.houseRegisteredArea}
                label="שטח מגורים"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmHouseRegisteredAreaWeightedValue"
                type={"text"}
                value={values.registeredSqmHouseRegisteredAreaWeightedValue}
                label="מקדם אקוו"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRegisteredAreaAdjusted"
                type={"text"}
                value={values.houseRegisteredAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseBalconyOpenRegisteredArea"
                type={"text"}
                value={values.houseBalconyOpenRegisteredArea}
                label="שטח מרפסות פתוחות"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredSqmOpenBalconyWeightedValue"
                type={"text"}
                value={values.registeredSqmOpenBalconyWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={13}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmOpenBalconyAreaAdjusted"
                type={"text"}
                value={values.registeredSqmOpenBalconyAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseBalconyClosedRegisteredArea"
                type={"text"}
                value={values.houseBalconyClosedRegisteredArea}
                label="שטח מרפסות סגורות"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredSqmClosedBalconyWeightedValue"
                type={"text"}
                value={values.registeredSqmClosedBalconyWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={14}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmClosedBalconyAreaAdjusted"
                type={"text"}
                value={values.registeredSqmClosedBalconyAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseYardRegisteredArea"
                type={"text"}
                value={values.houseYardRegisteredArea}
                label="שטח חצר"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredSqmYardWeightedValue"
                type={"text"}
                value={values.registeredSqmYardWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={15}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmYardAreaAdjusted"
                type={"text"}
                value={values.registeredSqmYardAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseRoofRegisteredArea"
                type={"text"}
                value={values.houseRoofRegisteredArea}
                label="שטח גג"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredSqmRoofWeightedValue"
                type={"text"}
                value={values.registeredSqmRoofWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={16}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmRoofAreaAdjusted"
                type={"text"}
                value={values.registeredSqmRoofAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          {/*<div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>*/}
          <div className={classnames(styles.flexBetween, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="houseStorageRegisteredArea"
                type={"text"}
                value={values.houseStorageRegisteredArea}
                label="שטח מחסן"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredSqmStorageWeightedValue"
                type={"text"}
                value={values.registeredSqmStorageWeightedValue}
                label="מקדם אקוו"
                onChange={limitValueRange(4, 0, 1)}
                handleDataSubmit={handleDataSubmit}
                calcTypeId={17}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmStorageAreaAdjusted"
                type={"text"}
                value={values.registeredSqmStorageAreaAdjusted}
                label="שטח מתואם"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.reverseRow, styles.marginBottom25, styles.threeQuartersField)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmTotalAdjustedArea"
                type={"text"}
                value={values.registeredSqmTotalAdjustedArea}
                label="שטח רשום כולל"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="averageSqmPriceUpperBorder"
                type={"text"}
                value={values.averageSqmPriceUpperBorder}
                label='גבול עליון ממוצע למ"ר'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInputEditMode
                fieldId="registeredSqmGeneralAdjustmentValue"
                type={"text"}
                value={values.registeredSqmGeneralAdjustmentValue}
                label="מקדם אקוו"
                onChange={limitValueRangeFloat(5, 0, 99.99)}
                handleDataSubmit={handleDataSubmit}
                showPercentIcon={true}
                calcTypeId={18}
                dirty={dirty}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="registeredSqmAverageUpperBorderPriceAdjusted"
                type={"text"}
                value={values.registeredSqmAverageUpperBorderPriceAdjusted}
                label='גבול עליון למ"ר מתואם'
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
            <div className={styles.quarterField}>
              <FieldInput
                fieldId="estimatePriceMethod3"
                type={"text"}
                value={values.estimatePriceMethod3}
                label="אומדן שווי"
                disabled
                containerCustomStyles={styles.widerField}
              />
            </div>
          </div>
        </div>
        }
        <div className={classnames(styles.reverseRow, styles.marginTop25)}>
          <div className={styles.quarterField}>
            <FieldInputEditMode
              fieldId="permitSqmFinalWeightedScale"
              type={"text"}
              value={values.permitSqmFinalWeightedScale}
              label='מקדם שווי מ"ר דירתי'
              onChange={limitValueRange(4, 0, 1)}
              handleDataSubmit={handleDataSubmit}
              calcTypeId={19}
              dirty={dirty}
            />
          </div>
        </div>
        <div className={classnames(styles.reverseRow, styles.marginTop25)}>
          <div className={styles.quarterField}>
            <FieldInputEditMode
              fieldId="registeredRoomFinalWeightedScale"
              type={"text"}
              value={values.registeredRoomFinalWeightedScale}
              label='מקדם שווי חדר ממוצע'
              onChange={limitValueRange(4, 0, 1)}
              handleDataSubmit={handleDataSubmit}
              calcTypeId={20}
              dirty={dirty}
            />
          </div>
        </div>
        {houseJointHomeRegistered === 1 &&
        <div className={classnames(styles.reverseRow, styles.marginTop25)}>
          <div className={styles.quarterField}>
            <FieldInputEditMode
              fieldId="registeredSqmFinalWeightedScale"
              type={"text"}
              value={values.registeredSqmFinalWeightedScale}
              label='מקדם שווי מ"ר רשום'
              onChange={limitValueRange(4, 0, 1)}
              handleDataSubmit={handleDataSubmit}
              calcTypeId={21}
              dirty={dirty}
            />
          </div>
        </div>
        }
        <div className={classnames(styles.reverseRow, styles.marginTop25)}>
          <div className={styles.quarterField}>
            <FieldInput
              fieldId="estimatePriceFinal"
              type={"text"}
              value={values.estimatePriceFinal}
              label="אומדן שווי מתואם"
              disabled
              containerCustomStyles={styles.widerField}
            />
          </div>
        </div>
        {shumaTypeID === 1 &&
        <div className={classnames(styles.reverseRow, styles.marginTop25)}>
          <div className={styles.quarterField}>
            <FieldInput
              fieldId="estimatePriceFinalRounded"
              type={"text"}
              dir={'ltr'}
              ltrDirection={true}
              showBird={false}
              value={divideThousandsInteger(values.estimatePriceFinalRounded)}
              onChange={formatStringToNumber}
              label={
                <div>
                  <span className={styles.mandatoryMark}>*</span>
                  אומדן שווי מתואם במעוגל
                </div>
              }
              containerCustomStyles={styles.widerField}
            />
          </div>
        </div>
        }
        <div className={styles.buttonsContainer}>
          <ButtonsSubmitCancel
            prevPagePath={prevPagePath}
            nextPagePath={nextPagePath}
          />
        </div>
      </Form>
      {houseJointHomeRegistered &&
      <UploadingFilePopUp
        showUploadingFilePopUp={showUploadingFilePopUp}
        progress={progress}
        message="אנא המתינו, שווי מתעדכן בעקבות השינוי"
      />
      }
    </div>
  )
};

Form_10View.propTypes = {
  values: PropTypes.object
};

export default Form_10View;
